import { render, staticRenderFns } from "./BadgeChoice.vue?vue&type=template&id=5be914ee&scoped=true"
import script from "./BadgeChoice.vue?vue&type=script&lang=js"
export * from "./BadgeChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be914ee",
  null
  
)

export default component.exports